import {
    ApolloClient,
    ApolloLink,
    createHttpLink,
} from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { RestLink } from 'apollo-link-rest';
import { InMemoryCache } from '@apollo/client/cache';
import _get from 'lodash/get';
import 'isomorphic-fetch';
import { resolvers, typeDefs } from '../resolvers';
import queries from '../queries';
const {
    GET_SEARCH_SORT,
    GET_SELECTED_FILTERS,
    GET_REEL,
    GET_PAGE,
    GET_MODALS,
    GET_NAV_ITEMS,
    GET_SHARE_MEDIA_ID,
    GET_DELETE_REEL_ID,
} = queries;

class GraphQLClient {

    constructor({
        server,
        vsmServer,
        data,
        isSSR = false,
    }) {

        this._server = server;
        this._vsmServer = vsmServer;
        this._data = data;
        this._isSSR = isSSR;
        this._client = this._clientInit();

    }

    getClient() {

        return this._client;

    }

    getState() {

        return this._client.extract();

    }

    _clientInit() {

        const httpLink = createHttpLink({
            uri: `${this._server}/graphql`,
            fetch: fetch,
            useGETForQueries: true,
        });

        const restLink = new RestLink({
            uri: this._vsmServer,
            fetch: fetch,
        });

        const cache = new InMemoryCache({
            freezeResults: true,
        });

        if (this._isSSR) {

            // TODO: rethink local state... local resolvers is deprecated -> Field Policies and/or reactive variables
            cache.writeQuery({
                query: GET_SEARCH_SORT,
                data: {
                    searchSort: null,
                },
            });
            cache.writeQuery({
                query: GET_SELECTED_FILTERS,
                data: {
                    selectedFilters: [],
                },
            });
            cache.writeQuery({
                query: GET_REEL,
                data: {
                    reel: {
                        reelTitle: null,
                        videoUrl: null,
                        thumbnailUrl: null,
                        duration: null,
                        reelClips: [],
                        __typename: 'Reel',
                    },
                },
            });
            cache.writeQuery({
                query: GET_PAGE,
                data: {
                    page: 0,
                },
            });
            cache.writeQuery({
                query: GET_MODALS,
                data: {
                    modals: '{}',
                },
            });
            cache.writeQuery({
                query: GET_NAV_ITEMS,
                data: {
                    navItems: _get(this._data, 'subnav.menuItems', []).map((item) => ({
                        id: _get(item, 'itemId', ''),
                        text: _get(item, 'text', ''),
                        link: _get(item, 'properties.link', ''),
                        __typename: 'navItem',
                    })),
                },
            });
            cache.writeQuery({
                query: GET_SHARE_MEDIA_ID,
                data: {
                    shareMediaId: '',
                },
            });
            cache.writeQuery({
                query: GET_DELETE_REEL_ID,
                data: {
                    deleteReelId: '',
                },
            });

        } else {

            cache.restore(this._data);

        }

        const client = new ApolloClient({
            link: getApolloLink(httpLink, restLink),
            cache,
            typeDefs,
            resolvers,
            connectToDevTools: true,
            ssrMode: this._isSSR,
        });

        return client;

    }

}

const getApolloLink = (httpLink, restLink) => {

    return ApolloLink.from([
        errorLink,
        restLink,
        httpLink,
    ]);

};

const errorLink = onError(({ networkError, graphQLErrors }) => {

    if (graphQLErrors) {

        graphQLErrors.map((error) =>

            console.log(
                `[GraphQL error]: ${error?.message}`
            )

        );

    }
    if (networkError) console.log(`[Network error]: ${networkError}`);

});

export default GraphQLClient;
